// Listing Card
export const LISTING_CARD_CLICK = 'listing-card-click'
export const LISTING_CARD_PHOTOS = 'listing-card-photos'
